var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacherAddChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3792_10687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4978 3C15.7604 3 3 15.7604 3 31.4978C3 47.2351 15.7604 59.9955 31.4978 59.9955C47.2351 59.9955 59.9955 47.2351 59.9955 31.4978C59.9955 15.7604 47.2351 3 31.4978 3ZM31.4978 55.1611C18.432 55.1611 7.83444 44.5635 7.83444 31.4978C7.83444 18.432 18.432 7.83444 31.4978 7.83444C44.5635 7.83444 55.1611 18.432 55.1611 31.4978C55.1611 44.5635 44.5635 55.1611 31.4978 55.1611Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3792_10687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2029 29.462H33.534V19.7931C33.534 19.5132 33.305 19.2842 33.0251 19.2842H29.9718C29.6919 19.2842 29.4629 19.5132 29.4629 19.7931V29.462H19.794C19.5142 29.462 19.2852 29.691 19.2852 29.9708V33.0242C19.2852 33.3041 19.5142 33.5331 19.794 33.5331H29.4629V43.2019C29.4629 43.4818 29.6919 43.7108 29.9718 43.7108H33.0251C33.305 43.7108 33.534 43.4818 33.534 43.2019V33.5331H43.2029C43.4828 33.5331 43.7118 33.3041 43.7118 33.0242V29.9708C43.7118 29.691 43.4828 29.462 43.2029 29.462Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3792_10687",
    x: 0,
    y: 0,
    width: 62.9961,
    height: 62.9951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3792_10687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3792_10687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3792_10687",
    x: 16.2852,
    y: 16.2842,
    width: 30.4258,
    height: 30.4268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3792_10687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3792_10687",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherAddChoice);
export default __webpack_public_path__ + "static/media/teacher_add_choice.c0f89a4f80dab6b5efe6868bf1c9a0ef.svg";
export { ForwardRef as ReactComponent };